import type { LandingPageContent } from '../types'

export const ZNAJDZ_INSTALATORA_FOTOWOLTAIKI: LandingPageContent = {
  slug: 'znajdz-instalatora-fotowoltaiki',
  lang: 'pl',
  topicId: 'pv-installateur-finden',
  title: 'Znajdź instalatora fotowoltaiki – sprawdzone firmy',
  metaDescription:
    'Znajdź instalatora fotowoltaiki dla swojego projektu. Firmy składają oferty na Twoje ' +
    'anonimowe zapytanie - Ty wybierasz, kto się skontaktuje.',
  keywords: [
    'znajdź instalatora fotowoltaiki',
    'firma instalująca panele słoneczne',
    'firma fotowoltaiczna',
    'znajdź firmę fotowoltaiczną',
    'instalator fotowoltaiki zabytek',
  ],
  eyebrow: 'Znajdź instalatora',
  h1: 'Znajdź odpowiedniego instalatora fotowoltaiki',
  intro:
    'Zamiast pisać do pojedynczych instalatorów i czekać na odpowiedź, w Roofora odwracasz ten ' +
    'proces: Twoje zapytanie dociera jednocześnie do kilku firm rzemieślniczych, które same składają ' +
    'ofertę.',
  sections: [
    { type: 'heading', text: 'Jak znaleźć instalatora w Roofora' },
    {
      type: 'paragraph',
      text:
        'Składasz anonimowe zapytanie z danymi dachu i zużyciem energii. Instalatorzy i firmy ' +
        'elektryczne w Twoim regionie widzą to zapytanie i mogą bezpłatnie złożyć ofertę - bez ' +
        'konieczności samodzielnego wyszukiwania czy kontaktowania się z poszczególnymi firmami.',
    },
    { type: 'heading', text: 'Co wyróżnia dobrego instalatora fotowoltaiki' },
    {
      type: 'list',
      items: [
        'Zrozumiała, konkretnie rozpisana oferta zamiast ceny ryczałtowej',
        'Opinie z zakończonych projektów',
        'Jasne warunki gwarancji i serwisu',
        'Doświadczenie z Twoim typem dachu i instalacji',
      ],
    },
    { type: 'heading', text: 'Regionalna dostępność firm rzemieślniczych' },
    {
      type: 'paragraph',
      text:
        'Ile firm złoży ofertę na Twoje zapytanie, zależy od Twojego regionu. W każdej chwili widzisz, ' +
        'ile ofert już wpłynęło, i możesz spokojnie poczekać, aż zbierze się wystarczająco dużo ' +
        'punktów odniesienia.',
    },
    { type: 'heading', text: 'Dla firm rzemieślniczych: znajdź projekty w swoim regionie' },
    {
      type: 'paragraph',
      text:
        'Instalatorzy i firmy elektryczne widzą anonimowe zapytania z ich regionu - z danymi dachu i ' +
        'zużyciem, ale bez danych kontaktowych. Złożenie oferty jest bezpłatne i bez zobowiązań.',
    },
  ],
  faq: [
    {
      q: 'Czy muszę sam wyszukiwać firmy rzemieślnicze?',
      a: 'Nie - składasz zapytanie, a odpowiednie firmy z Twojego regionu same składają na nie oferty.',
    },
    {
      q: 'Skąd wiem, czy instalator jest wiarygodny?',
      a: 'Możesz zobaczyć profil każdej firmy wraz z opiniami, zanim zdecydujesz, czy zezwolisz jej na kontakt, i porównać kilka ofert przed podjęciem decyzji.',
    },
    {
      q: 'Czy znajdę też instalatora z doświadczeniem w obiektach zabytkowych?',
      a: 'Tak - podaj status ochrony zabytków swojego budynku w zapytaniu. Firmy z odpowiednim doświadczeniem mogą złożyć ofertę celowo pod takie zlecenie, bez konieczności samodzielnego ich szukania.',
    },
  ],
  primaryCta: { label: 'Złóż zapytanie i znajdź instalatorów', action: 'customer' },
  secondaryCta: { label: 'Zarejestruj się jako firma rzemieślnicza', action: 'craftsman' },
  relatedLinks: [
    { label: 'Jak działa porównanie ofert', href: '/porownaj-oferty-fotowoltaiczne' },
    { label: 'Złóż zapytanie fotowoltaiczne', href: '/zlozyc-zapytanie-fotowoltaiczne' },
    { label: 'Koszt instalacji fotowoltaicznej', href: '/koszt-instalacji-fotowoltaicznej' },
    { label: 'Potrzebujesz tylko montażu na dachu?', href: '/montaz-paneli-fotowoltaicznych' },
    { label: 'Potrzebujesz tylko instalacji elektrycznej?', href: '/instalacja-elektryczna-fotowoltaiki' },
  ],
}
